import React, { useState } from 'react';
import { ZapIcon, InfoIcon, ShoppingBagIcon } from 'lucide-react';
import { Button } from './common/Button';
import { Popup } from './common/Popup';
import { motion } from 'framer-motion';
import { ElephantMascot } from './ElephantMascot';
export function HeroSection() {
  const [showPopup, setShowPopup] = useState(false);
  const handleDownloadClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowPopup(true);
  };
  const handleOkClick = () => {
    setShowPopup(false);
  };
  return <section className="relative overflow-hidden pt-16 pb-28 bg-[#FFFC00]" data-id="element-278" data-mp="30k96kig4fvl2">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-279" data-mp="2mu5toi34te8a">
        <div className="flex flex-col items-center text-center mb-16" data-id="element-280" data-mp="2ms323tmbzd1g">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-281" data-mp="2rrfpqgl10o53">
            <h1 className="text-5xl sm:text-7xl md:text-8xl font-black mb-6 leading-[0.9] uppercase tracking-tight text-[#1A1A1A]" data-id="element-282" data-mp="2fgjz2wfxvko4">
              <span className="block" data-id="element-283" data-mp="2bfrnhwjlh3oo">Get Perks At</span>
              <span className="block" data-id="element-284" data-mp="2p5ldii6u5tzz">Your Local Spots.</span>
            </h1>
            <p className="text-xl md:text-2xl text-[#1A1A1A] mb-10 max-w-2xl mx-auto font-medium" data-id="element-285" data-mp="2keva3ahz017x">
              India's #1st coffee social app. Join exclusive IRL Coffee Club,
              before your friends do.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-286" data-mp="2u3d67efb1k58">
              <Button variant="primary" size="lg" onClick={handleDownloadClick} className="text-xl py-4 px-10 border-[3px] border-white shadow-[4px_4px_0px_0px_rgba(255,255,255,0.6)] hover:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.6)] hover:translate-x-[2px] hover:translate-y-[2px] transition-all duration-200" data-id="element-287" data-mp="384pldnmn5hq2">
                Get Kraya
              </Button>
            </div>
          </motion.div>
        </div>

        {/* Hero phone mockup */}
        <motion.div className="relative max-w-sm mx-auto mt-12 md:mt-0" initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-288" data-mp="3dt7crm99rq1f">
          {/* Mascot Peeking — top-left of phone */}
          <div className="absolute top-4 -left-44 md:-left-64 z-30 hidden sm:block" data-id="element-289" data-mp="kuioag93jfk">
            <ElephantMascot size="sm" direction="right" noBg message={<>
                  Psst... we're
                  <br data-id="element-291" data-mp="edkhjfgvoiu3" />
                  <span className="text-[#FFFC00]" data-id="element-292" data-mp="ee2d09vput0y">invite only</span>{' '}
                  <img src="https://cdn.magicpatterns.com/uploads/mr2Zsrm9w3bh1MAbJ8aXFT/envelope.png" alt="💌" className="inline-block w-5 h-5 align-middle" data-id="element-293" data-mp="jc451kb4e2ok" />
                </>} className="transform rotate-6 hover:rotate-0 transition-transform duration-300" data-id="element-290" data-mp="5c2vzhkpboy0" />
          </div>

          <div className="relative bg-[#1A1A1A] p-4 rounded-[3.5rem] shadow-2xl transform hover:-translate-y-2 transition-transform duration-500" data-id="element-294" data-mp="1pun54xr8rm5e">
            {/* Decorative elements */}
            <div className="absolute -top-8 -right-8 bg-[#FFFC00] h-20 w-20 rounded-full animate-pulse border-4 border-[#1A1A1A] z-10 flex items-center justify-center shadow-lg" data-id="element-295" data-mp="2mmqn1po28bvn">
              <ZapIcon className="h-10 w-10 text-[#1A1A1A] fill-current" data-id="element-296" data-mp="2dqrioczziam2" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white border-4 border-[#1A1A1A] h-16 w-16 rounded-full animate-bounce z-10 flex items-center justify-center shadow-lg overflow-hidden" data-id="element-297" data-mp="28szmv7w7y4cl">
              <iframe src="https://lottie.host/embed/f47ad52d-91a4-4313-acd1-bacd8f020d26/kIuzOcGc25.lottie" className="w-10 h-10 border-0 pointer-events-none" title="Shopping animation" data-id="element-298" data-mp="31gltyq4nnr47" />
            </div>
            <div className="absolute top-1/3 -right-12 bg-white border-2 border-[#1A1A1A] shadow-xl rounded-xl p-3 animate-float z-20" data-id="element-299" data-mp="2c2r8dh4fm9sn">
              <div className="flex items-center" data-id="element-300" data-mp="2h1c8zhnlivhm">
                <span className="text-xl font-black text-[#1A1A1A]" data-id="element-301" data-mp="34q4x4rxz7z1o">
                  +10 Drops!
                </span>
              </div>
            </div>

            <div className="bg-[#F9F9F6] rounded-[2.5rem] overflow-hidden border-2 border-gray-800 h-[650px]" data-id="element-302" data-mp="38uclup4fpezw">
              {/* App screenshot */}
              <div className="pt-8 px-6 pb-12 h-full flex flex-col" data-id="element-303" data-mp="2zz50lnsrrizp">
                {/* App header */}
                <div className="flex items-center justify-between mb-8" data-id="element-304" data-mp="3np95dyhp1osa">
                  <div className="text-xl font-bold text-[#1A1A1A]" data-id="element-305" data-mp="3sfz8t66k7hkc">
                    Hey, Arjun! 👋
                  </div>
                  <div className="h-10 w-10 bg-[#FFFC00] rounded-full border-2 border-[#1A1A1A]" data-id="element-306" data-mp="5ollip1w0rc6"></div>
                </div>

                {/* Featured section */}
                <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5 mb-6" data-id="element-307" data-mp="ff6t31zjh678">
                  <div className="flex items-center mb-4" data-id="element-308" data-mp="agdhjf3tbp9p">
                    <div className="bg-[#FFFC00] p-2 rounded-lg mr-3" data-id="element-309" data-mp="ah5asj9xtawt">
                      <ShoppingBagIcon className="h-5 w-5 text-[#1A1A1A]" data-id="element-310" data-mp="3ix875svlnd5u" />
                    </div>
                    <h3 className="font-bold text-lg text-[#1A1A1A]" data-id="element-311" data-mp="3evmxeged3ezv">
                      Featured Rewards
                    </h3>
                  </div>
                  <div className="grid grid-cols-2 gap-3" data-id="element-312" data-mp="3nv9oo9ddn4f7">
                    <div className="rounded-xl h-24 overflow-hidden border border-gray-100" data-id="element-313" data-mp="3ntovoo6pntjg">
                      <img src="https://images.unsplash.com/photo-1509042239860-f550ce710b93" alt="Coffee shop" className="w-full h-full object-cover" data-id="element-314" data-mp="182ucweszjsst" />
                    </div>
                    <div className="rounded-xl h-24 overflow-hidden border border-gray-100" data-id="element-315" data-mp="1f6kc2gy26rdm">
                      <img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5" alt="Restaurant" className="w-full h-full object-cover" data-id="element-316" data-mp="1k5wzp3wr82h9" />
                    </div>
                    <div className="rounded-xl h-24 overflow-hidden border border-gray-100" data-id="element-317" data-mp="rfwpqqnebz7j">
                      <img src="https://images.unsplash.com/photo-1534452203293-494d7ddbf7e0" alt="Retail store" className="w-full h-full object-cover" data-id="element-318" data-mp="wehqqsah2mx1" />
                    </div>
                    <div className="rounded-xl h-24 overflow-hidden border border-gray-100" data-id="element-319" data-mp="8qqdnmh3y5up">
                      <img src="https://images.unsplash.com/photo-1594631252845-29fc4cc8cde9" alt="Bakery" className="w-full h-full object-cover" data-id="element-320" data-mp="dorx48ig476p" />
                    </div>
                  </div>
                </div>

                {/* Nearby section */}
                <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5 flex-1" data-id="element-321" data-mp="3nf79s39b1cev">
                  <div className="flex items-center mb-4" data-id="element-322" data-mp="3jd3luf5g8fcp">
                    <div className="bg-[#1A1A1A] p-2 rounded-lg mr-3" data-id="element-323" data-mp="3jeoh66zl82bm">
                      <ZapIcon className="h-5 w-5 text-[#FFFC00]" data-id="element-324" data-mp="3elltuglelp3v" />
                    </div>
                    <h3 className="font-bold text-lg text-[#1A1A1A]" data-id="element-325" data-mp="39oloy90aisec">
                      Nearby Spots
                    </h3>
                  </div>
                  <div className="space-y-4" data-id="element-326" data-mp="34mmlkz4jvvhe">
                    <div className="flex items-center" data-id="element-327" data-mp="2zob9ehqs98w0">
                      <div className="h-12 w-12 rounded-xl mr-4 overflow-hidden border border-gray-100" data-id="element-328" data-mp="2vnrelktomhd1">
                        <img src="https://images.unsplash.com/photo-1559925393-8be0ec4767c8" alt="Coffee shop" className="w-full h-full object-cover" data-id="element-329" data-mp="nf30qm1i6y6q" />
                      </div>
                      <div data-id="element-330" data-mp="dj9icm13sah1">
                        <div className="text-base font-bold text-[#1A1A1A]" data-id="element-331" data-mp="ifgqmlgz1y25">
                          Morning Brew
                        </div>
                        <div className="text-sm text-gray-500 font-medium" data-id="element-332" data-mp="4n0lnf4ifpyl">
                          0.2 miles away
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-333" data-mp="3qxcwdi4msymv">
                      <div className="h-12 w-12 rounded-xl mr-4 overflow-hidden border border-gray-100" data-id="element-334" data-mp="3vud2tu5e83ei">
                        <img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5" alt="Restaurant" className="w-full h-full object-cover" data-id="element-335" data-mp="3huv70utojpvn" />
                      </div>
                      <div data-id="element-336" data-mp="2y9l7ouo38v1c">
                        <div className="text-base font-bold text-[#1A1A1A]" data-id="element-337" data-mp="2yad6sfgw9awd">
                          Local Bistro
                        </div>
                        <div className="text-sm text-gray-500 font-medium" data-id="element-338" data-mp="3c6qb0mwf3fsw">
                          0.5 miles away
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-339" data-mp="3m4xpmz38hlrq">
                      <div className="h-12 w-12 rounded-xl mr-4 overflow-hidden border border-gray-100" data-id="element-340" data-mp="3h74hw1ma8jpc">
                        <img src="https://images.unsplash.com/photo-1472851294608-062f824d29cc" alt="Bookstore" className="w-full h-full object-cover" data-id="element-341" data-mp="3uyasotv0i3rj" />
                      </div>
                      <div data-id="element-342" data-mp="3u2n3x9xbocb">
                        <div className="text-base font-bold text-[#1A1A1A]" data-id="element-343" data-mp="3uudmtonyvvq">
                          Page Turner
                        </div>
                        <div className="text-sm text-gray-500 font-medium" data-id="element-344" data-mp="2m24ze7clwh3f">
                          0.7 miles away
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Popup */}
      <Popup isOpen={showPopup} onClose={() => setShowPopup(false)} title={<div className="flex items-center gap-2" data-id="element-346" data-mp="35qdqsf6bsj1v">
            <InfoIcon className="h-6 w-6 text-[#1A1A1A]" data-id="element-347" data-mp="30qj4koxhwhn5" />
            <span className="font-bold text-xl" data-id="element-348" data-mp="30oy9my79qwor">Note</span>
          </div>} data-id="element-345" data-mp="39qxnxiqwfmo0">
        <div className="space-y-6" data-id="element-349" data-mp="2vrg6xpjuhdp7">
          <p className="text-gray-600 text-lg font-medium" data-id="element-350" data-mp="1pbm7crr5qm4p">
            Please join our waitlist and get referral rewards. We are launching
            soon!
          </p>
          <Button variant="primary" size="full" href="https://kraya.live/" onClick={handleOkClick} data-id="element-351" data-mp="1kem4eppltzht">
            Join Waitlist
          </Button>
        </div>
      </Popup>

      <style jsx data-id="element-352" data-mp="1k720yd559onu">{`
        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-15px);
          }
          100% {
            transform: translateY(0px);
          }
        }
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
      `}</style>
    </section>;
}